import isType from './is-type';
var isDate = function (value) {
    return isType(value, 'Date');
};
export default isDate;
//# sourceMappingURL=is-date.js.map